<template>
    <div class = "main pt-3 w-100 h-100 d-flex flex-column">
        <div class = "buttons text-center mb-3">
          <b-button variant="info" size="sm" @click="recenterMap()" class="mr-1">
                    Recenter Map
          </b-button>
          <b-button variant="success" size="sm" @click="reloadMarkers()" class="mr-1">
                    Reload Markers
          </b-button>
        </div>
        <div class="grow">
            <GmapMap ref="mapRef"
                :center="mapCenter"
                :zoom="mapZoom"
                map-type-id="terrain"
                style="width: 100%; height: 100%;"
            >
                <GmapMarker
                    :key="index"
                    v-for="(marker, index) in markers"
                    :position="{
                        lat: marker.latitude,
                        lng: marker.longitude
                    }"
                    :clickable="true"
                    :draggable="false"
                    :icon="marker.type === 'location' ? locationMarker : marker.type === 'job' ? jobMarker : technicianMarker"
                    @click="marker.type === 'job' && getJobInfo(marker.id)"
                >
                    <!-- @click="showMarkerInfo(marker, index)"
                    <gmap-info-window
                        :options="infoOptions"
                        :position="infoWindowPos"
                        :opened="infoWinOpen"
                        @closeclick="infoWinOpen = false"
                    >
                        <div v-html="infoContent"></div>
                    </gmap-info-window> -->
                    <!-- <gmap-info-window
                        v-if="(marker.latitude && marker.longitude) && marker.type === 'job'"
                        :opened="isToolTipsOpen"
                        :position="{
                            lat: marker.latitude,
                            lng: marker.longitude
                        }"
                    >
                        <p class="body-2">{{marker.jobTypes[0].jobType}}</p>    
                        <v-btn color="primary block" @click="getJobInfo(marker.id)">
                            View Job
                        </v-btn>
                    </gmap-info-window> -->
                </GmapMarker>
            </GmapMap>
        </div>
        <JobDialog v-if='details' :jobInfo='jobInfo' :show="details" @close="details = false" />
    </div>
</template>

<script>
import JobDialog from './JobDialog.vue';

export default {
    name: "JobMap",
    components: {
        JobDialog,
    },
    created() {
        this.getJobAddress()
        this.getAllLocations()
        this.getAllTechnicians()
    },
    data(){
        return{
            jobMarker: {
                    url: require('../../assets/job_marker.png'),
                    size: {width: 30, height: 30, f: 'px', b: 'px',},
                    scaledSize: {width: 30, height: 30, f: 'px', b: 'px',},
            }, 
            locationMarker: {
                    url: require('../../assets/location_marker1.png'),
                    size: {width: 30, height: 35, f: 'px', b: 'px',},
                    scaledSize: {width: 30, height: 35, f: 'px', b: 'px',},
            },
            technicianMarker: {
                    url: require('../../assets/technician_marker.png'),
                    size: {width: 35, height: 35, f: 'px', b: 'px',},
                    scaledSize: {width: 35, height: 35, f: 'px', b: 'px',},
            },
            techRefresher: null,
            jobInfo: null,
            details: false,
            map: {},
            platform: {},
            geocoder: {},
            markers: [],
            mapCenter: { lat:43.2557, lng:-79.8711 },
            mapZoom: 12,
            infoContent: '',
            infoWindowPos: {
                lat: 0,
                lng: 0
            },
            infoWinOpen: false,
            isToolTipsOpen: false,
            currentMindex: null,
            //optional: offset infowindow so it visually sits nicely on top of our marker
            infoOptions: {
                pixelOffset: {
                    width: 0,
                    height: -35
                }
            },
        }        
    },
    mounted: function () {
        //Runs the 'reloadMarkers' function every 5 minutes
        this.$nextTick(function () {
            window.setInterval(() => {
                this.reloadMarkers();
            },300000);
        })
    },
    watch:{
        markers(){
            window.setTimeout(() => {
                this.recenterMap();
            }, 500);
        }
    },
    methods: {
        showMarkerInfo(marker, index) {
            const { id, type } = marker
            if(type === 'location' || type === 'technician') {
                this.toggleInfoWindow(marker, index)
            } else if (type === 'job') {
                this.getJobInfo(id)
            } else {
                this.$overlay.hide()
                return;
            }
        },
        getJobInfo(id) {
          this.$overlay.show(this)
          this.$api
            .getJobById(id)
            .then(res => {
                if (res.status == 200) {
                    this.jobInfo = res.data;
                    this.details = true;
                }
                this.$overlay.hide()
            })
            .catch(() => {
                this.$overlay.hide()
            })
        },
        getJobAddress() {
            this.$api.getAllJobs().then(res => {
                if (res.status == 200) {
                    const markers = res.data;
                    this.$overlay.hide(this)
                    for(const marker of markers) {
                        this.markers.push({
                            ...marker,
                            colour: this.markerColour('yellow'),
                            type: 'job'
                        })
                    }
                }
            }
        )},
        getAllLocations() {
            this.$api.getLocations().then(res => {
                if (res.status == 200) {
                    const markers = res.data
                    for (const marker of markers) {
                        this.markers.push({
                            ...marker,
                            type: 'location',
                            colour: this.markerColour('red'),
                        })
                    }
                    this.isToolTipsOpen = true;
                }
            })
        },
        getAllTechnicians() {
            this.$api.getAllTechnicians().then(res => {
                if (res.status == 200) {
                    const markers = res.data
                    for (const marker of markers) {
                        this.markers.push({
                            ...marker,
                            type: 'technician',
                            colour: this.markerColour('green'),
                        })
                    }
                }
            })
        },
        getTechniciansTimely() {
            this.techRefresher = setInterval(() => {
                this.getAllTechnicians
            }, 10000)
        },
        markerColour(colour){
            switch(colour){
                case "orange":
                    return "http://maps.google.com/mapfiles/ms/icons/orange-dot.png"
                case "purple":
                    return "http://maps.google.com/mapfiles/ms/icons/purple-dot.png"
                case "blue":
                    return "http://maps.google.com/mapfiles/ms/icons/blue-dot.png"    
                case "green":
                    return "http://maps.google.com/mapfiles/ms/icons/green-dot.png"
                case "yellow":
                    return "http://maps.google.com/mapfiles/ms/icons/yellow-dot.png"
                case "red":
                    return "http://maps.google.com/mapfiles/ms/icons/red-dot.png"
                default:
                    return ""
            }             
        },
        recenterMap(){
            this.mapCenter = { lat:43.2557, lng:-79.8711 }
            this.mapZoom = 12
            this.$refs.mapRef.$mapPromise.then((map) => {
                map.panTo(this.mapCenter);
                map.setZoom(this.mapZoom);
            })
        },
    reloadMarkers(){
        clearInterval(this.techRefresher);
        this.$overlay.show(this)
        this.markers = [];
        this.getJobAddress();
        this.getAllLocations();
        this.getAllTechnicians();
        // this.getTechniciansTimely();
    },
      toggleInfoWindow: function (marker, index) {
        this.infoWindowPos = {
            lat: marker.latitude,            
            lng: marker.longitude,            
        };
        this.infoContent = this.getInfoWindowContent(marker);
        this.$refs.mapRef.$mapPromise.then((map) => {
            map.panTo({
                lat: marker.latitude,
                lng: marker.longitude
            })
        })
        //check if its the same marker that was selected if yes toggle
        if (this.currentMarkerIndex == index) {
          this.infoWinOpen = !this.infoWinOpen;
        }
        //if different marker set infowindow to open and reset current marker index
        else {
          this.infoWinOpen = true;
          this.currentMarkerIndex = index;
        }
      },
      getInfoWindowContent: function (marker) {
        return (
            `<div class="card">
                <div class="card-content">
                    <div class="media">
                        <div class="media-content">
                            <p class="title is-4">${marker.type === 'technician' ? `${marker.fname} ${marker.lname}` : marker.name}</p>
                        </div>
                    </div>
                    <div class="content">
                        ${marker.type === 'technician' ? marker.email : marker.description}
                        <br>
                    </div>
                </div>
            </div>`
        );
      }
    }
}
</script>

<style scoped>
    div ::v-deep .gm-ui-hover-effect {
        display: none !important;
    }
</style>